import { useContext } from 'react';
import { ChatUnreadCountContext, SetChatUnreadCountContext } from './chatUnreadContexts.js';

export function useChatUnreadCount() {
  return useContext(ChatUnreadCountContext);
}

export function useSetChatUnreadCount() {
  return useContext(SetChatUnreadCountContext);
}
